import type { FaqItem } from './faq.types';

type FaqAccordionItemProps = {
  item: FaqItem;
  isOpen: boolean;
  showDivider: boolean;
  onToggle: () => void;
};

export function FaqAccordionItem({ item, isOpen, showDivider, onToggle }: FaqAccordionItemProps) {
  return (
    <div
      className={`faq-item py-[26px] cursor-pointer relative ${showDivider ? '[box-shadow:inset_0_1px_0_var(--color-outline-variant)]' : ''} ${isOpen ? 'open' : ''}`}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle();
        }
      }}
      role="button"
      tabIndex={0}
      aria-expanded={isOpen}
    >
      <div className="q flex justify-between gap-8 items-center">
        <h4 className="font-display text-[clamp(18px,1.8vw,26px)] font-normal tracking-[-0.01em] m-0 transition-colors duration-[240ms] leading-[1.3] [text-wrap:balance]">
          {item.q}
        </h4>
        <span className="plus font-mono text-on-surface-variant text-[22px] transition-[transform,color] duration-[340ms] shrink-0">
          +
        </span>
      </div>
      <div className="a max-h-0 overflow-hidden transition-[max-height,padding,opacity] duration-[400ms] ease-out opacity-0">
        <p className="m-0 max-w-[72ch] text-on-surface-variant leading-[1.6] text-[15px]">{item.a}</p>
      </div>
    </div>
  );
}
